import { DynamicCellRenderers } from '@/common/Table/cells/DynamicCell';
import { progressBarCellRenderer } from '@/pages/Reports/DynamicReport/components/ReportTable/components/ProgressBarCell';
import { statusCellRenderer } from '@/pages/Reports/DynamicReport/components/ReportTable/components/StatusCell';
import { tooltipCellRenderer } from '@/pages/Reports/DynamicReport/components/ReportTable/components/TooltipCell';

// TODO: Replace this with barrel-exports when we add more renderers
const cellRenderers: DynamicCellRenderers = {
  progressBar: progressBarCellRenderer,
  status: statusCellRenderer,
  tooltip: tooltipCellRenderer,
};
export default cellRenderers;
